import { ISC } from 'core/constants/channels'
import { IS_ENROLL } from 'core/constants/environment'
import { getPivotBlueshiftParams } from 'core/services/email/blueshift/implementations/generic'
import store from 'utils/store/withMiddleware'
import { BlueshiftEvent, sendBlueshiftEvent } from 'core/services/email/blueshift'

export function sendQuotesViewEvent(): Promise<void> {
  const state = <Pivot.GenericKeyPair<any>>store.getState()
  const { hcStorage } = state

  const dataPayload = {
    ...getPivotBlueshiftParams()
  }

  if (!IS_ENROLL) {
    dataPayload.coverage_start_date = hcStorage.sdate
  }

  if (dataPayload.sales_channel === ISC) {
    dataPayload.agent_id = hcStorage.agent_id
    dataPayload.isc_lead_stage = 'Quote Sent'
    dataPayload.isc_lead_status = 'Working - Contacted'
  }

  return sendBlueshiftEvent({
    dataPayload,
    eventName:
      dataPayload.sales_channel === ISC
        ? BlueshiftEvent.ISC_QUOTES_VIEW
        : BlueshiftEvent.QUOTES_VIEW,
    sanitize: true
  })
}
